module.exports = __webpack_public_path__ + "img/forest.b997f4af.jpg";